import { useGetPrimaryAddressQuery } from "types/generated/operations";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getProspectUuid } from "utils/idHelpers";
import PrimaryBusinessAddress from "./PrimaryBusinessAddress";
import { getAppType } from "utils/helper";

const PrimaryBusinessAddressModel = () => {
  const { data, error, loading } = useGetPrimaryAddressQuery({
    variables: { uuid: getProspectUuid(), appType: getAppType() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return <PrimaryBusinessAddress data={data?.prospect} />;
};
export default PrimaryBusinessAddressModel;
